import React from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { connect } from '../../../reducers/index';
import { url } from '../../../constants/routes';
import './styles.css';
import EducationModuleLayout from '../../../components/Layout/EducationModuleLayout';
// import IdentifyGraphic02 from '../img/male-with-bubbles-graphic.svg';
// import IcebergGraphic from './img/iceberg-graphic.svg';
// import GaugeGraphic from './img/emotion-gauge-graphic.svg';

const IdentifyPage = props => {
  return (
    <EducationModuleLayout
      progressStage={4}
      childTitle="Identify"
      progressType="identify"
    >
      <section className="no-bottom-padding">
        <div className="container">
          <Row className="text-center">
            <Col md={12}>
              <h2 className="txt-purple no-bold">Behaviours, Thoughts and Feelings: What to look for</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <p>
                Some behaviours, thoughts, and feelings are common, everyday responses to life.
                These become concerning when they <strong>persist over a period of time </strong>
                (e.g., multiple days or weeks), <strong>occur frequently</strong>, or seem to be
                having a <strong>significant impact</strong> on the individual. Examples can include:
              </p>
            </Col>
          </Row>
          <Row>
            <Col xs={10} xsOffset={1}>
              <ul className="list-group">
                <li className="list-group-item">sadness or tearfulness</li>
                <li className="list-group-item">worry or anxiety</li>
                <li className="list-group-item">problems sleeping</li>
                <li className="list-group-item">difficulty concentrating</li>
                <li className="list-group-item">general irritability</li>
                <li className="list-group-item">
                  missing class or not handing in academic work
                </li>
                <li className="list-group-item">
                  requests for special consideration (e.g., assignments, work
                  shifts)
                </li>
                <li className="list-group-item">
                  problems with friends, family or roommates
                </li>
                <li className="list-group-item">
                  vacant staring and/or daydreaming
                </li>
                <li className="list-group-item">
                  requests to talk or meet with you
                </li>
                <li className="list-group-item">
                  changes in appetite and/or weight
                </li>
                <li className="list-group-item">hyperactivity</li>
                <li className="list-group-item">
                  avoidance from and/or withdrawal from the activities they
                  once cared about
                </li>
              </ul>
            </Col>
          </Row>
        </div>
      </section>
      <section>
        <div className="container text-center">
          <Row>
            <Col xs={12}>
              <Button
                className="btn btn-purple previous"
                onClick={() => props.history.goBack()}
              >
                Previous
              </Button>
              <LinkContainer
                to={url.IDENTIFY_E}
                className="next btn btn-purple"
              >
                <Button>Next</Button>
              </LinkContainer>
            </Col>
          </Row>
        </div>
      </section>
    </EducationModuleLayout>
  );
};

IdentifyPage.propTypes = {
  role: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const IdentifyD = IdentifyPage;
export default connect.role(IdentifyD);



// WEBPACK FOOTER //
// ./src/containers/Identify/IdentifyD/index.jsx